import isUndefined from 'lodash/isUndefined';
import isPlainObject from 'lodash/isPlainObject';

export default function cleanProps(props) {
  const obj = {};

  for (const [key, value] of Object.entries(props)) {
    if (!isUndefined(value)) {
      obj[key] = isPlainObject(value) ? cleanProps(value) : value;
    }
  }

  return obj;
}
